import React from 'react';

interface NavItemProps {
  label: string;
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
}

export const NavItem = React.memo(function NavItem({ label, active, onClick, icon }: NavItemProps) {
  return (
    <button onClick={onClick} className={`nav-item ${active ? "nav-item-active" : ""}`}>
      <span className="nav-icon">{icon}</span>
      {label}
    </button>
  );
});
